export enum eLoaiQuyetDinh {
  cau_hoi = 0,
  de_thi = 1,
}
